<template>
  <div class="corporate-info">
    <v-container class="mb-6">
      <v-stepper v-model="corporateStepper" flat vertical>
        <v-stepper-items>
          <!-- first stepper for corporate information  -->
          <v-stepper-step
            :complete="corporateStepper > 1"
            :rules="[() => this.corporateInfoError]"
            step="1"
            color="#434343"
            class="adjust_stepper_all_h"
          >
            Corporate Information
          </v-stepper-step>
          <v-stepper-content step="1" class="adjust_v_stepper">
            <v-form ref="formCorpInfo">
              <v-row class="ma-0">
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Corporate Name <span class="red--text"><strong>*</strong></span></label>
                  <v-text-field
                    v-model="corporate_information.corporate_name"
                    color="#434343"
                    :rules="TextRules"
                    maxlength="51"
                    placeholder="Enter Corparate Name"
                    outlined
                    dense
                    name="corporate_name"
                    id="corporate_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Registration Number <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="corporate_information.registration_number"
                    color="#434343"
                    outlined
                    placeholder="Enter Registeration Number"
                    maxlength="51"
                    :rules="TextRules"
                    label=""
                    dense
                    name="registeration-number"
                    id="registeration_number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
              <label for="">Incorporation Date <span class="red--text"><strong>* </strong></span></label>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="corporate_information.incorporation_date"
                        :rules="[v => !!v || 'Required']"
                        label=""
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        placeholder="Enter Incorporation Date"
                        v-bind="attrs"
                        v-on="on"
                        name="incorporation_date"
                        id="incorporation_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="corporate_information.incorporation_date"
                      @input="menu = false"
                      :max="todayDate"
                    ></v-date-picker>
                  </v-menu>
                  <!-- <v-text-field
                    v-model="incorporation_date"
                    color="#434343"
                    :rules="[v => !!v || 'Required']"
                    outlined
                    placeholder
                    maxlength="51"
                    label="Incorporation Date"
                    type="date"
                    dense
                    name="incorporation_date"
                    id="incorporation_date"
                  ></v-text-field> -->
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Registered Street Address <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="TextRules"
                    v-model="corporate_information.registered_address"
                    color="#434343"
                    outlined
                    placeholder="Enter Registered Street Address"
                    maxlength="51"
                    label=""
                    dense
                    name="registered_street_address"
                    id="registered_street_address"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>City <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="TextRules"
                    v-model="corporate_information.city"
                    color="#434343"
                    outlined
                    placeholder="Enter City"
                    maxlength="51"
                    label=""
                    dense
                    name="corporate_city"
                    id="corporate_city"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Country <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="TextRules"
                    v-model="corporate_information.country"
                    color="#434343"
                    outlined
                    placeholder="Enter Country"
                    maxlength="51"
                    label=""
                    dense
                    name="corporate_country"
                    id="corporate_country"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Postal Code <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="TextRules"
                    v-model="corporate_information.postal_code"
                    color="#434343"
                    outlined
                    placeholder="Enter Postal Code"
                    maxlength="51"
                    label=""
                    dense
                    name="corporate_postal_code"
                    id="corporate_postal_code"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>VAT Number <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="TextRules"
                    v-model="corporate_information.VAT_number"
                    color="#434343"
                    outlined
                    placeholder="Enter VAT Number"
                    maxlength="51"
                    label=""
                    dense
                    type="number"
                    name="corporate_vat_number"
                    id="corporate_vat_number"
                  ></v-text-field>
                </v-col>
                  
              </v-row>
            </v-form>
            <v-btn
              color="#434343"
              dark
              @click="updateCorporateInfoSection()"
              class="float-end mb-2"
              >Next</v-btn
            >
          </v-stepper-content>

          <!-- stepper containing information for contact details  -->
          <!-- <v-stepper-step
            :complete="corporateStepper > 2"
            :rules="[() => this.primaryContactError]"
            step="2"
            color="#434343"
            class="adjust_stepper_all_h"
          >
            Contact Details
          </v-stepper-step> -->
          <v-stepper-content step="27">
            <h3 class="text-center my-3" style="color: #434343">
              Primary Contact Details
            </h3>
            <v-form ref="formPrimaryContact">
              <v-row class="ma-0">
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Contact Name <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    color="#434343"
                    outlined
                    placeholder="Enter Contact Name "
                    maxlength="51"
                    :rules="TextRules"
                    v-model="primary_contact_details.contact_name"
                    label=""
                    dense
                    name="primary_contact_name"
                    id="primary_contact_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Contact Number <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="TextRules"
                    v-model="primary_contact_details.phone_no"
                    color="#434343"
                    outlined
                    placeholder="Enter Contact Number"
                    maxlength="51"
                    label=""
                    dense
                    name="primary_contact_number"
                    id="primary_contact_number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label>Email <span class="red--text"><strong>* </strong></span></label>

                  <v-text-field
                    :rules="emailRules"
                    v-model="primary_contact_details.email"
                    color="#434343"
                    outlined
                    placeholder="Enter Email"
                    maxlength="51"
                    label=""
                    dense
                    name="primary_contact_email"
                    id="primary_contact_email"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Position <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="primary_contact_details.position"
                    color="#434343"
                    outlined
                    placeholder="Enter Position"
                    maxlength="51"
                    label=""
                    dense
                    name="primary_contact_position"
                    id="primary_contact_position"
                  ></v-text-field>
                </v-col>
              </v-row>

              <h3 class="text-center my-3" style="color: #434343">
                Financial Contact Details
              </h3>
              <v-row class="ma-0">
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Contact Name <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="financial_contact_details.contact_name"
                    color="#434343"
                    outlined
                    placeholder="Enter Contact Name "
                    maxlength="51"
                    label=""
                    dense
                    name="financial_contact_name"
                    id="financial_contact_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Contact Number <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="financial_contact_details.phone_no"
                    color="#434343"
                    outlined
                    placeholder="Enter Contact Number"
                    maxlength="51"
                    label=""
                    dense
                    name="financial_contact_number"
                    id="financial_contact_number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Email <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="emailRules"
                    v-model="financial_contact_details.email"
                    color="#434343"
                    outlined
                    placeholder="Enter Email"
                    maxlength="51"
                    label=""
                    dense
                    name="financial_contact_email"
                    id="financial_contact_email"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Position <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="financial_contact_details.position"
                    color="#434343"
                    outlined
                    placeholder="Enter Position"
                    maxlength="51"
                    label=""
                    dense
                    name="financial_contact_position"
                    id="financial_contact_position"
                  ></v-text-field>
                </v-col>
              </v-row>

              <h3 class="text-center my-3" style="color: #434343">
                Technical Contact Details
              </h3>
              <v-row class="ma-0">
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Contact Name <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="technical_contact_details.contact_name"
                    color="#434343"
                    outlined
                    placeholder="Enter Contact Name"
                    maxlength="51"
                    label=""
                    dense
                    name="technical_contact_name"
                    id="technical_contact_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Contact Number <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="technical_contact_details.phone_no"
                    color="#434343"
                    outlined
                    placeholder="Enter Contact Number"
                    maxlength="51"
                    label=""
                    dense
                    name="technical_contact_number"
                    id="technical_contact_number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Email <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="emailRules"
                    v-model="technical_contact_details.email"
                    color="#434343"
                    outlined
                    placeholder="Enter Email"
                    maxlength="51"
                    label=""
                    dense
                    name="technical_contact_email"
                    id="technical_contact_email"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Position <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    :rules="TextRules"
                    v-model="technical_contact_details.position"
                    color="#434343"
                    outlined
                    placeholder="Enter Position"
                    maxlength="51"
                    label=""
                    dense
                    name="technical_contact_position"
                    id="technical_contact_position"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-btn
              color="#434343"
              dark
              @click="updatePrimaryContactDetailsSection()"
              class="float-end mb-2"
              >Next</v-btn
            >
            <v-btn
              text
              @click="corporateStepper = 1"
              class="mb-2 float-end mx-1 adjust-pre-btn"
              >Previous</v-btn
            >
          </v-stepper-content>

          <!-- director details section  -->

          <!-- <v-stepper-step
            :complete="corporateStepper > 3"
            :rules="[() => this.directorsError]"
            step="3"
            color="#434343"
            class="adjust_stepper_all_h"
          >
            Directors Details
          </v-stepper-step> -->
          <v-stepper-content step="3">
            <v-form ref="formDirectors">
              <v-row
                class="ma-0"
                v-for="(director, index) in directors"
                :key="index"
              >
                <v-col cols="12">
                  <h3 class="mb-4 text-center" style="color: #434343">
                    Information of Director {{ index + 1 }}
                    <v-icon
                      class="ml-2"
                      @click="deleteDirector(director)"
                      v-if="index != 0"
                    >
                      mdi-delete</v-icon
                    >
                  </h3>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">First Name <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.first_name"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter First Name"
                    maxlength="51"
                    label=""
                    dense
                    name="director_first_name"
                    id="director_first_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Last Name <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.last_name"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Last Name"
                    maxlength="51"
                    label=""
                    dense
                    name="director_last_name"
                    id="director_last_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Date of Birth <span class="red--text"><strong>* </strong></span></label>
                  <v-menu
                    :value="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="director.date_of_birth"
                        :rules="[v => !!v || 'Required']"
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        placeholder="Enter Date of Birth"
                        v-bind="attrs"
                        v-on="on"
                        name="director_dob"
                        id="director_dob"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="director.date_of_birth"
                      @input="menu1 = false"
                      :max="todayDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Passport Number <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.passport_no"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Passport Number"
                    maxlength="51"
                    label=""
                    dense
                    name="director_passport_no"
                    id="director_passport_no"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Country of Passport <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.passport_country"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Country of Passport"
                    maxlength="51"
                    label=""
                    dense
                    name="director_passport_country"
                    id="director_passport_country"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Residing Street Address <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.residing_address"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Residing Street Address"
                    maxlength="51"
                    label=""
                    dense
                    name="director_residing_address"
                    id="director_residing_address"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">City <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.city"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter City "
                    maxlength="51"
                    label=""
                    dense
                    name="director_city"
                    id="director_city"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Country <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.country"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Country"
                    maxlength="51"
                    label=""
                    dense
                    name="director_country"
                    id="director_country"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Postal Code <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="director.postal_code"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Postal Code"
                    maxlength="51"
                    label=""
                    dense
                    name="director_postal_code"
                    id="director_postal_code"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <!-- <label for="">Relative or Public Post <span class="red--text"><strong>* </strong></span></label> -->
                  <br> <span class="caption font-weight-medium">
                      DO YOU OR ANY OF YOUR RELATIVES HOLD A POLITICAL OR
                          PUBLIC<br />POST OR HAVE YOU IN THE PAST?
                   </span> <br>
                   <v-checkbox dense class="float-left">
                      <template v-slot:label>
                        <span class="">No</span>
                      </template>
                    </v-checkbox> &nbsp;
                   <v-checkbox dense class="float-left">
                      <template v-slot:label>
                        <span class="">Yes</span>
                      </template>
                    </v-checkbox> &nbsp;
                    <v-text-field
                    dense
                    placeholder="if yes please specify"
                    class=" mt-n5">

                    </v-text-field>
                
                </v-col>
                <v-col cols="4" class="mt-6">
                  <v-checkbox
                    v-model="director.is_US_resident"
                    :label="`Resident of United States?`"
                    class="mt-2"
                    color="#434343"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
            <v-icon @click="addDirector()" class="ml-1">
              mdi-plus-thick
            </v-icon>
            <v-btn
              color="#434343"
              dark
              @click="updateDirectors()"
              class="float-end mb-2"
              >Next</v-btn
            >
            <v-btn
              text
              @click="corporateStepper = 2"
              class="mb-2 float-end mx-1 adjust-pre-btn"
              >Previous</v-btn
            >
          </v-stepper-content>
          <!-- stepper 4 for shareholders details  -->
          <!-- <v-stepper-step
            :complete="corporateStepper > 4"
            :rules="[() => this.shareholdersError]"
            step="4"
            color="#434343"
            class="adjust_stepper_all_h"
          >
            Shareholder Details
          </v-stepper-step> -->
          <v-stepper-content step="4">
            <v-form ref="formShareholders">
              <v-row
                class="ma-0"
                v-for="(shareholder, index) in shareholders"
                :key="index"
              >
                <v-col cols="12">
                  <h3 class="mb-4 text-center" style="color: #434343">
                    Information of Shareholder {{ index + 1 }}
                    <v-icon
                      class="ml-2"
                      @click="deleteShareHolder(shareholder)"
                      v-if="index != 0"
                    >
                      mdi-delete</v-icon
                    >
                  </h3>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Percentage of Company Ownership <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.percentage"
                    color="#434343"
                    outlined
                    placeholder="Enter Percentage of Company Ownership"
                    maxlength="51"
                    :rules="TextRules"
                    label=""
                    dense
                    type="number"
                    name="shareholder_company_ownershop"
                    id="shareholder_company_ownershop"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">First Name <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.first_name"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter First Name"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_first_name"
                    id="share_first_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Last Name <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.last_name"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Last Name"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_last_name"
                    id="shareholder_last_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Date of Birth <span class="red--text"><strong>* </strong></span></label>
                  <v-menu
                    :value="modal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="shareholder.date_of_birth"
                        :rules="[v => !!v || 'Required']"
                        label=""
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        placeholder="Enter Date of Birth "
                        v-bind="attrs"
                        v-on="on"
                        name="shareholder_dob"
                        id="shareholder_dob"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="shareholder.date_of_birth"
                      @input="modal = false"
                      :max="todayDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Passport Number <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.passport_no"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Passport Number"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_passport_no"
                    id="shareholder_passport_no"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Country of Passport <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.passport_country"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Country of Passport"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_passport_country"
                    id="shareholder_passport_country"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Residing Street Address <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.residing_address"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Residing Street Address"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_residing_address"
                    id="shareholder_residing_address"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">City <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.city"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter City "
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_city"
                    id="shareholder_city"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Country <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.country"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Country"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_country"
                    id="shareholder_country"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Postal Code <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.postal_code"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Postal Code"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_postal_code"
                    id="shareholder_postal_code"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <!-- <span class="red--text"><strong>* </strong></span> -->
                  <label for="">Relative or Public Post <span class="red--text"><strong>* </strong></span></label>
                  <v-text-field
                    v-model="shareholder.relative_public_figure"
                    :rules="TextRules"
                    color="#434343"
                    outlined
                    placeholder="Enter Relative or Public Post"
                    maxlength="51"
                    label=""
                    dense
                    name="shareholder_relative_public_post"
                    id="shareholder_relative_public_post"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-alert-circle-outline
                          </v-icon>
                        </template>
                        <small
                          >DO YOU OR ANY OF YOUR RELATIVES HOLD A POLITICAL OR
                          PUBLIC<br />POST OR HAVE YOU IN THE PAST? (IF YES,
                          PLEASE SPECIFY)</small
                        >
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="mt-6">
                  <v-checkbox
                    v-model="shareholder.is_US_resident"
                    :label="`Resident of United States?`"
                    class="mt-2"
                    color="#434343"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
            <v-icon @click="addShareHolder()" class="ml-1">
              mdi-plus-thick
            </v-icon>
            <v-btn
              color="#434343"
              dark
              @click="updateShareholders()"
              class="mb-2 float-end"
            >
              Continue
            </v-btn>
            <v-btn
              text
              @click="corporateStepper = 3"
              class="mb-2 float-end mx-1 adjust-pre-btn"
              >Previous</v-btn
            >
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
// import PrimaryContactDetails from "./PrimaryContactDetails.vue";
// import Directors from "./Directors.vue";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  // components: {
  //   Directors,
  //   PrimaryContactDetails
  // },
  name: "CorporateInfo",
  data() {
    return {
      todayDate: "",
      deleteDirectorId: "",
      deleteShareHolderId: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],

      modal: false,
      menu: false,
      menu1: false,
      corporateInfoError: !this.$store.state.corporateInfoError,
      primaryContactError: !this.$store.state.contactDetailsError,
      directorsError: !this.$store.state.directorsDetailsError,
      shareholdersError: !this.$store.state.shareholderDetailsError,
      corporateStepper: 1,
      TextRules: [v => !!v || "Required"],

      corporate_information: {
        corporate_name: "",
        registration_number: "",
        incorporation_date: "",
        registered_address: "",
        city: "",
        country: "",
        postal_code: "",
        VAT_number: "",
        business_address: "",
        business_city: "",
        business_country: "",
        business_postal_code: ""
      },

      primary_contact_details: {
        contact_name: "",
        phone_no: "",
        email: "",
        position: ""
      },
      financial_contact_details: {
        contact_name: "",
        phone_no: "",
        email: "",
        position: ""
      },
      technical_contact_details: {
        contact_name: "",
        phone_no: "",
        email: "",
        position: ""
      },
      directors: [
        // {
        //   form_id: 1,
        //   first_name: "",
        //   last_name: "",
        //   date_of_birth: "",
        //   passport_no: "",
        //   passport_country: "",
        //   residing_address: "",
        //   city: "",
        //   country: "",
        //   postal_code: "",
        //   relative_public_figure: "",
        //   is_US_resident: false
        // }
      ],
      shareholders: [
        // {
        //   form_id: 1,
        //   percentage: "",
        //   first_name: "",
        //   last_name: "",
        //   date_of_birth: "",
        //   passport_no: "",
        //   passport_country: "",
        //   residing_address: "",
        //   city: "",
        //   country: "",
        //   postal_code: "",
        //   relative_public_figure: "",
        //   is_US_resident: false
        // }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getFormId",
      "getUserId",
      "getCorporateID",
      "getPrimaryID",
      "getTechnicalID",
      "getFinancialID"
    ])
  },
  methods: {
    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },
    // get directors
    getDirectors() {
      axios
        .post(
          "/directorsDetail",
          {
            user_id: this.getUserId,
            form_id: this.getFormId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.directors = res.data.directorsDetail;
          // console.log("hi")
        })
        .catch(err => {
          console.log(err, "cryp mount err");
        });
    },
    // add more directors
    addDirector() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "/createDirectorId",
            {
              user_id: this.getUserId,
              form_id: this.getFormId
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            resolve(res);
            // console.log(res.data, "add new dir");
            this.directors.push(res.data.director);
          })
          .catch(err => {
            reject(err);
            console.log(err, "add new dir er");
          });
      });
    },

    // update directors
    updateDirectors() {
      // this is validating fields of Directors stepper
      if (!this.$refs.formDirectors.validate()) {
        this.$store.dispatch("updateDirectorsDetailsError", true);
        this.directorsError = !true;
      } else {
        this.$store.dispatch("updateDirectorsDetailsError", !true);
        this.directorsError = true;
      }
      axios
        .post(
          "createDirector",
          {
            directorsDetails: this.directors,
            form_id: this.getFormId,
            user_id: this.getUserId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "directors");
        })
        .catch(err => {
          console.log(err.response, "dir_err");
        });
      this.corporateStepper = 4;
    },

    // delete director
    deleteDirector(director) {
      this.directors.filter(item => {
        if (item.id == director.id) {
          this.deleteDirectorId = director.id;
        }
      });

      axios
        .post(
          "/deleteDirector",
          {
            id: this.deleteDirectorId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.getDirectors();
        })
        .catch(err => {
          console.log(err, "deleted err");
        });
    },
    // update corporation information
    // updateCorporateInfoSection() {
    //       // this.corporateStepper = 2;
    //   // this is validating fields of corporate info stepper
    //   if (!this.$refs.formCorpInfo.validate()) {
        
    //     this.$store.dispatch("updateCorporateInfoError", true);
    //     this.corporateInfoError = !true;
    //   } else {
    //     this.$store.dispatch("updateCorporateInfoError", !true);
    //     this.corporateInfoError = true;
    //   }

    //   // Update Corporate Information
    //   axios
    //     .post(
    //       "/createCorporateInformation",
    //       {
    //         form_id: this.getFormId,
    //         user_id: this.getUserId,
    //         corporate_form: this.corporate_information,
    //         corporate_id: this.getCorporateID
    //       },
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.getItem("token")
    //         }
    //       }
    //     )
    //     .then(res => {
    //       // this.$store.dispatch("corporateId", res.data.corporate_id);
    //       // console.log(res.data, "added");
    //     })
    //     .catch(err => {
    //       console.log(err.response.data);
    //     });

    //   this.corporateStepper = 2;
    //    this.updateIndex(2);
    // },

    // update primary contact details
    updatePrimaryContactDetailsSection() {
      // this.corporateStepper=2;
      // this is validating fields of primary contact stepper
      if (!this.$refs.formPrimaryContact.validate()) {
        this.$store.dispatch("updateContactDetailsError", true);
        this.primaryContactError = !true;
      } else {
        this.$store.dispatch("updateContactDetailsError", !true);
        this.primaryContactError = true;
      }
      axios
        .post(
          "/createContactDetails",
          {
            form_id: this.getFormId,
            user_id: this.getUserId,
            primary_contact_detail_id: this.getPrimaryID,
            financial_contact_detail_id: this.getFinancialID,
            technical_contact_detail_id: this.getTechnicalID,
            primary_contact_detail: this.primary_contact_details,
            financial_contact_detail: this.financial_contact_details,
            technical_contact_detail: this.technical_contact_details
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "contact details");
        })
        .catch(err => {
          console.log(err.response);
        });
      this.corporateStepper = 3;
      this.updateIndex(3);
    },

    // get share holders
    getShareHolder() {
      axios
        .post(
          "/shareholdersDetail",
          {
            user_id: this.getUserId,
            form_id: this.getFormId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.shareholders = res.data.shareholderDetail;
        })
        .catch(err => {
          console.log(err, "share mount err");
        });
    },
    // add more share holder
    addShareHolder() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "/createShareholderId",
            {
              user_id: this.getUserId,
              form_id: this.getFormId
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            resolve(res);
            // console.log(res.data, "add new share");
            this.shareholders.push(res.data.shareholder);
          })
          .catch(err => {
            reject(err);
            console.log(err, "add new share er");
          });
      });
    },
    // Update Share holders
    updateShareholders() {
      if (!this.$refs.formShareholders.validate()) {
        this.$store.dispatch("updateShareholdersDetailsError", true);
        this.shareholdersError = !true;
      } else {
        this.$store.dispatch("updateShareholdersDetailsError", !true);
        this.shareholdersError = true;
      }
      axios
        .post(
          "/createShareholder",
          {
            shareholderDetails: this.shareholders,
            form_id: this.getFormId,
            user_id: this.getUserId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "shareholders");
        })
        .catch(err => {
          console.log(err.response, "share err");
        });
      this.updateIndex(2),
        // this.$store.dispatch("updateShareholderDetails", this.shareholders);
        this.$store.dispatch("incrementStepper");
    },
    // delete share holder
    deleteShareHolder(shareholder) {
      this.shareholders.filter(item => {
        if (item.id == shareholder.id) {
          this.deleteShareHolderId = shareholder.id;
        }
      });

      axios
        .post(
          "/deleteShareholder",
          {
            id: this.deleteShareHolderId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.getShareHolder();
        })
        .catch(err => {
          console.log(err, "deleted err");
        });
    }
  },
  mounted() {
    let today = new Date();
    this.todayDate = today.toISOString().slice(0, 10);
    // get corporate form
    axios
      .post(
        "/corporateForm",
        {
          form_id: this.getFormId,
          user_id: this.getUserId
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        // console.log(res.data.corporateForm, "mounted");
        (this.corporate_information.corporate_name =
          res.data.corporateForm.corporate_name == null
            ? ""
            : res.data.corporateForm.corporate_name),
          (this.corporate_information.registration_number =
            res.data.corporateForm.registration_number == null
              ? ""
              : res.data.corporateForm.registration_number),
          (this.corporate_information.incorporation_date =
            res.data.corporateForm.incorporation_date == null
              ? ""
              : res.data.corporateForm.incorporation_date),
          (this.corporate_information.registered_address =
            res.data.corporateForm.registered_address == null
              ? ""
              : res.data.corporateForm.registered_address),
          (this.corporate_information.city =
            res.data.corporateForm.city == null
              ? ""
              : res.data.corporateForm.city),
          (this.corporate_information.country =
            res.data.corporateForm.country == null
              ? ""
              : res.data.corporateForm.country),
          (this.corporate_information.postal_code =
            res.data.corporateForm.postal_code == null
              ? ""
              : res.data.corporateForm.postal_code),
          (this.corporate_information.VAT_number =
            res.data.corporateForm.VAT_number == null
              ? ""
              : res.data.corporateForm.VAT_number),
          (this.corporate_information.business_address =
            res.data.corporateForm.business_address == null
              ? ""
              : res.data.corporateForm.business_address),
          (this.corporate_information.business_city =
            res.data.corporateForm.business_city == null
              ? ""
              : res.data.corporateForm.business_city),
          (this.corporate_information.business_country =
            res.data.corporateForm.business_country == null
              ? ""
              : res.data.corporateForm.business_country),
          (this.corporate_information.business_postal_code =
            res.data.corporateForm.business_postal_code == null
              ? ""
              : res.data.corporateForm.business_postal_code);
        // this.corporate_information = res.data.corporateForm;
      })
      .catch(err => {
        console.log(err.response, "err");
      });

    // get contact details form
    axios
      .post(
        "/contactDetailsForm",
        {
          form_id: this.getFormId,
          user_id: this.getUserId
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        // console.log(res.data, "contact details");
        this.primary_contact_details.contact_name =
          res.data.primaryContactDetail.contact_name == null
            ? ""
            : res.data.primaryContactDetail.contact_name;
        this.primary_contact_details.phone_no =
          res.data.primaryContactDetail.phone_no == null
            ? ""
            : res.data.primaryContactDetail.phone_no;
        this.primary_contact_details.email =
          res.data.primaryContactDetail.email == null
            ? ""
            : res.data.primaryContactDetail.email;
        this.primary_contact_details.position =
          res.data.primaryContactDetail.position == null
            ? ""
            : res.data.primaryContactDetail.position;

        this.financial_contact_details.contact_name =
          res.data.financialContactDetail.contact_name == null
            ? ""
            : res.data.financialContactDetail.contact_name;
        this.financial_contact_details.phone_no =
          res.data.financialContactDetail.phone_no == null
            ? ""
            : res.data.financialContactDetail.phone_no;
        this.financial_contact_details.email =
          res.data.financialContactDetail.email == null
            ? ""
            : res.data.financialContactDetail.email;
        this.financial_contact_details.position =
          res.data.financialContactDetail.position == null
            ? ""
            : res.data.financialContactDetail.position;

        this.technical_contact_details.contact_name =
          res.data.technicalContactDetail.contact_name == null
            ? ""
            : res.data.technicalContactDetail.contact_name;
        this.technical_contact_details.phone_no =
          res.data.technicalContactDetail.phone_no == null
            ? ""
            : res.data.technicalContactDetail.phone_no;
        this.technical_contact_details.email =
          res.data.technicalContactDetail.email == null
            ? ""
            : res.data.technicalContactDetail.email;
        this.technical_contact_details.position =
          res.data.technicalContactDetail.position == null
            ? ""
            : res.data.technicalContactDetail.position;
      })
      .catch(err => {
        console.log(err.response, "err");
      });

    this.getDirectors();
    this.getShareHolder();
    this.TextRules.push(v => v.length <= 50 || "Max 50 characters");
  }
};
</script>

<style scoped>
.adjust-pre-btn {
font-size: 11px !important;
}</style>
